import React from 'react'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import ChatListNavUI from '../../../components/superUser/account/ChatListNavUI.js'
import ChatMessageListSF from '../../../components/superUser/account/ChatMessageListSF.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'

const ChatFollowUpUI = ({ context, errorList, chatMessageList, userMessageList, onRefreshClick }) =>
  <SuperUserPageSF context={context} className='pg_su_acc_l'
    headerText='Accounts' centered={!chatMessageList}
  >
    {
      !errorList && !chatMessageList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      chatMessageList &&
      <div>
        <ChatListNavUI page='followUp' />

        <ChatMessageListSF
          context={context}
          messageList={chatMessageList}
          userMessageList={userMessageList}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }
    {
      chatMessageList && chatMessageList.length === 0 &&
      <EmptyListUI
        context={context} className='g_m_top_200'
        createDisabledMessageLabel='No messages'
      />
    }
  </SuperUserPageSF>

export default ChatFollowUpUI
